import type { SVGProps } from 'react';
const SvgCollection = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.833 9.167H4.167m11.666 0c.92 0 1.667.746 1.667 1.666v5c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.746-1.667-1.667v-5c0-.92.746-1.666 1.667-1.666m11.666 0V7.5c0-.92-.746-1.667-1.666-1.667m-10 3.334V7.5c0-.92.746-1.667 1.666-1.667m0 0V4.167c0-.92.747-1.667 1.667-1.667h5c.92 0 1.667.746 1.667 1.667v1.666m-8.334 0h8.334"
    />
  </svg>
);
export default SvgCollection;
